// src/errors.ts
var ValidationError = class extends Error {
};

export {
  ValidationError
};
